module.exports = __webpack_public_path__ + "img/11.09b06c7f.webp";